module.exports = __webpack_public_path__ + "media/fr.b1156355.svg";